import { Fancybox } from '@fancyapps/ui';

export function initFancybox() {
	Fancybox.bind('[data-fancybox]', {
		Carousel: {
			Thumbs: {
				type: 'classic',
			},
		},
	});
}

export { Fancybox };
